/**
 * Carga imágenes de fondo solo cuando su sección se acerca al viewport.
 * Evita que banners inferiores compitan con el hero y el contenido crítico.
 */
(function() {
  'use strict';

  var observer = null;

  function loadBackground(element) {
    var source = element.getAttribute('data-lazy-background');
    if (!source) return;

    var property = element.getAttribute('data-lazy-background-property');
    var value = 'url("' + source.replace(/"/g, '%22') + '")';
    if (property) {
      element.style.setProperty(property, value);
    } else {
      element.style.backgroundImage = value;
    }

    element.removeAttribute('data-lazy-background');
    element.removeAttribute('data-lazy-background-property');
    if (observer) observer.unobserve(element);
  }

  function elementsWithin(root) {
    var elements = [];
    if (root && root.matches && root.matches('[data-lazy-background]')) elements.push(root);
    if (root && root.querySelectorAll) {
      elements = elements.concat(Array.prototype.slice.call(root.querySelectorAll('[data-lazy-background]')));
    }
    return elements;
  }

  function observeBackgrounds(root) {
    var elements = elementsWithin(root || document);
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(loadBackground);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) loadBackground(entry.target);
        });
      }, { rootMargin: '600px 0px' });
    }

    elements.forEach(function(element) {
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      observeBackgrounds(document);
    });
  } else {
    observeBackgrounds(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    observeBackgrounds(event.target);
  });
})();
